(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/simple-article/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/content/simple-article/assets/javascripts/init.js');
"use strict";

const init = () => {
  const {
    setupVideoFromAttributes
  } = svs.components.emp_video_player.helpers.client;
  const simpleArticles = document.getElementsByClassName('simple-article');
  for (let index = 0; index < simpleArticles.length; index++) {
    const redbeeVideoElement = simpleArticles[index].querySelectorAll('.js-emp-placeholder');
    for (let index = 0; index < redbeeVideoElement.length; index++) {
      const video = redbeeVideoElement[index];
      setupVideoFromAttributes(video);
    }
  }
};
init();

 })(window);